<template>
  <div>
    <div class="radio-inline">
      <RadioGroup :options="channels"
                  :showlabel="true"
                  :label="$t('notification_channel')"
                  v-model="object.notification_channel_id"/>
    </div>
    <div class="radio-inline">
      <RadioGroup :options="timeOptions"
                  :showlabel="true"
                  :label="$t('send_time')"
                  v-model="hasTime"/>
    </div>
    <div v-if="hasTime === '1'">
      <div class="row align-items-center">
        <div class="col">
          <DateGroup :label="$t('send_date')"
                     v-model="date"/>
        </div>
        <div class="col">
          <TimeGroup :label="$t('time')"
                     v-model="time"/>
        </div>
      </div>
    </div>
    <AutosizeTextArea
        :label="$t('text')"
        :show-errors="true"
        validation-id="text"
        :max-length="850"
        :required="true"
        v-model="object.text"/>
    <FileGroup fid="file-attachment"
               :label="$t('image')"
               v-if="Number(object.notification_channel_id) === 6"
               v-model="object.imageUrl"
               :deletefile="true"
               :filetype="'image'"/>
    <TagsList type="mailing"
              class="mt-0">
      {{ $t('tags_for_marketing_mailing') }}
    </TagsList>
  </div>
</template>

<script>
import RadioGroup from '@/components/form/RadioGroup'
import AutosizeTextArea from "@/components/form/AutosizeTextArea"
import DateGroup from "@/components/form/DateGroup"
import TimeGroup from "@/components/form/TimeGroup"
import TagsList from "@/components/parts/crm/TagsList.vue"
import { mapGetters } from "vuex"
import FileGroup from "@/components/form/FileGroup.vue"

export default {
  name: "MarketingMailingAdditionalFormComponent",
  components: {
    FileGroup,
    TagsList,
    TimeGroup,
    DateGroup,
    AutosizeTextArea,
    RadioGroup
  },
  props: {
    object: {
      type: Object
    },
    options: {},
  },
  computed: {
    datetime() {
      return this.date+' '+this.time+':00'
    },
    ...mapGetters(['telegramBotEnabled', 'maxEnabled']),
    channels() {
      const arr = [
        { id: '1', title: 'sms_message' },
        // { id: '3', title: 'push_notification' },
        { id: '4', title: 'whatsapp' },
      ]
      if(this.telegramBotEnabled) {
        arr.push({ id: '6', title: 'telegram_bot' })
      }
      if(this.maxEnabled) {
        arr.push({ id: '9', title: 'max_bot' })
        // arr.push({ id: '7', title: 'Max' })
      }
      return arr
    }
  },
  data() {
    return {
      timeOptions: [
        { id: '0', title: 'immediately_after_creating' },
        { id: '1', title: 'given_time' },
      ],
      hasTime: this.object.send_time ? '1' : '0',
      date: this.object.send_time ? this.object.send_time.substr(0, 10) : null,
      time: this.object.send_time ? this.object.send_time.substr(11, 5) : null,
    }
  },
  watch: {
    date() {
      this.object.send_time = this.datetime
    },
    time() {
      this.object.send_time = this.datetime
    }
  }
}
</script>
